import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const MoreDevelopmentsGroup = styled.div`
  background-color: ${(props) => props.theme.backgroundLightest};
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 60px 0;

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const MoreDevelopmentsText = styled.div`
  display: flex;
  flex-direction: row;

  svg {
    margin-right: 15px;
  }

  h4 {
    color: ${(props) => props.theme.textDark};
    font-size: 20px;
  }

  p {
    color: ${(props) => props.theme.textLight};
    font-size: 16px;
  }

  b {
    color: ${(props) => props.theme.primary};
  }

  @media (${laptopMediumMax}) {
    margin-bottom: 30px;
    flex-direction: column;
    align-items: center;

    svg {
      margin: 0 0 15px 0;
    }

    h4,
    p {
      text-align: center;
    }
  }
`;
